var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/x-excalidraw.ts
import { css } from "@adornis/chemistry/directives/css.js";
import { FormField } from "@adornis/formfield/form-field.js";
import "@adornis/popover/x-dropdown-search-selection.js";
import { goTo } from "@adornis/router/client/open-href.js";
import { getScrollParent } from "@adornis/shadowroot-helpers/get-scroll-parent.js";
import { createComponent } from "@lit/react";
import { html } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { createRef, ref } from "lit/directives/ref.js";
import { unsafeHTML } from "lit/directives/unsafe-html.js";
import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import { debounceTime, fromEvent, takeUntil } from "rxjs";
import { ExcalidrawData } from "../db/ExcalidrawData.js";
window.process = { env: {} };
var XExcalidraw = class extends FormField {
  constructor() {
    super(...arguments);
    this.mode = "edit";
    this.excalidrawContainer = createRef();
    this.styleDivRef = createRef();
  }
  render() {
    if (this.svgString && (this.mode === "view" || this.mode === "print"))
      return html` ${unsafeHTML(this.svgString)} `;
    return html`
      <div ${css({ height: "100%" })} ${ref(this.excalidrawContainer)}></div>
      <div ${ref(this.styleDivRef)}></div>
    `;
  }
  async firstUpdated(changedProperties) {
    super.firstUpdated(changedProperties);
    const { Excalidraw, Footer } = await import("@excalidraw/excalidraw");
    const App = () => {
      let parsedContent;
      try {
        parsedContent = JSON.parse(this.value.value?.content ?? "[]");
      } catch {
        parsedContent = [];
      }
      const [api, setAPI] = useState();
      useEffect(() => {
        if (api) {
          this.excalidrawAPI = api;
          this.generateSvg();
        }
      }, [api]);
      return React.createElement(
        React.Fragment,
        null,
        React.createElement(
          Excalidraw,
          {
            // * this doesn't work due to webcomponents. Check usage of getScrollParent below for our workaround
            // detectScroll: true,
            excalidrawAPI: (api2) => setAPI(api2),
            initialData: {
              elements: parsedContent,
              files: JSON.parse(this.value.value?.binaryFiles ?? "{}"),
              scrollToContent: true
            },
            onLinkOpen(element, event) {
              if (!element.link)
                return;
              event.preventDefault();
              event.stopPropagation();
              goTo(element.link);
            },
            onChange: async (elements, appState, files) => {
              this.value.next(
                new ExcalidrawData({
                  content: JSON.stringify(api?.getSceneElementsIncludingDeleted()),
                  binaryFiles: JSON.stringify(files)
                })
              );
            }
          },
          this.footerElement ? React.createElement(
            Footer,
            {},
            React.createElement(
              createComponent({
                tagName: this.footerElement.tag,
                elementClass: this.footerElement.class,
                react: React,
                events: {}
              }),
              {
                excalidrawAPI: api
              }
            )
          ) : void 0
        )
      );
    };
    if (!this.styleDivRef.value || !this.excalidrawContainer.value)
      return alert("cant find excalidraw wrapper");
    const root = ReactDOM.createRoot(this.excalidrawContainer.value);
    root.render(React.createElement(App));
    for (const style of Array.from(document.head.querySelectorAll("style") ?? [])) {
      const newStyle = document.createElement("style");
      newStyle.innerHTML = style.innerHTML;
      this.styleDivRef.value.appendChild(newStyle);
    }
  }
  connectedCallback() {
    super.connectedCallback();
    const scrollParent = getScrollParent(this);
    if (scrollParent)
      fromEvent(scrollParent, "scroll").pipe(debounceTime(300), takeUntil(this.disconnected)).subscribe(() => this.excalidrawAPI?.refresh());
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    setTimeout(() => {
      const tooltip = document.body.querySelector(".excalidraw-tooltip");
      if (tooltip)
        document.body.removeChild(tooltip);
    }, 300);
  }
  async generateSvg() {
    if (this.svgString)
      return;
    if (!this.excalidrawAPI) {
      console.error("Excalidraw API is not available");
      return;
    }
    const elements = this.excalidrawAPI.getSceneElements();
    const appState = this.excalidrawAPI.getAppState();
    const files = this.excalidrawAPI.getFiles();
    const { exportToSvg } = await import("@excalidraw/excalidraw");
    const svg = await exportToSvg({
      elements,
      appState,
      exportPadding: 10,
      files
    });
    svg.setAttribute("width", "100%");
    svg.setAttribute("height", this.height ? this.height : "500px");
    svg.querySelector("rect")?.setAttribute("fill", "transparent");
    const svgString = new XMLSerializer().serializeToString(svg);
    this.svgString = svgString;
  }
  styles() {
    return [...super.styles(), { ":host": { display: "block", height: "100%" } }];
  }
};
__decorateClass([
  property({ attribute: false })
], XExcalidraw.prototype, "footerElement", 2);
__decorateClass([
  property({ attribute: false })
], XExcalidraw.prototype, "mode", 2);
__decorateClass([
  property({ attribute: false })
], XExcalidraw.prototype, "height", 2);
__decorateClass([
  state()
], XExcalidraw.prototype, "svgString", 2);
XExcalidraw = __decorateClass([
  customElement("x-excalidraw")
], XExcalidraw);
export {
  XExcalidraw
};
